import React,{useState} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiPhone,FiMapPin,FiMail,FiClock,FiSend}=FiIcons;

function Contact() {
  const [formData,setFormData]=useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleChange=(e)=> {
    setFormData({...formData,[e.target.name]: e.target.value});
  };

  const handleSubmit=(e)=> {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:',formData);
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
  };

  const contactInfo=[
    {icon: FiPhone,title: 'Phone',details: '+1 (416) 637-9929',link: 'tel:+14166379929'},
    {icon: FiMapPin,title: 'Address',details: '2925 Dundas St W,Toronto,ON M6P 1Z1,Canada',link: 'https://maps.app.goo.gl/uot5v9b8f7euibJm7'},
    {icon: FiMail,title: 'Email',details: 'info@westendbarbers.com',link: 'mailto:info@westendbarbers.com'},
    {icon: FiClock,title: 'Hours',details: 'Mon-Sun: 9:00 AM - 8:00 PM',link: null}
  ];

  const services=[
    'Classic Haircut','Beard Trim & Shape','Hot Towel Shave','Hair Wash & Style','Mustache Grooming','Complete Grooming Package'
  ];

  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} transition={{duration: 0.5}} className="flex-1" >
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-black via-gray-900 to-black py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 initial={{y: 50,opacity: 0}} animate={{y: 0,opacity: 1}} transition={{delay: 0.2,duration: 0.8}} className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6" >
            Contact <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">Us</span>
          </motion.h1>
          <motion.p initial={{y: 50,opacity: 0}} animate={{y: 0,opacity: 1}} transition={{delay: 0.4,duration: 0.8}} className="text-xl text-gray-400 max-w-2xl mx-auto" >
            Get in touch with us to book your appointment or ask any questions
          </motion.p>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {contactInfo.map((info,index)=> (
              <motion.div key={index} initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{delay: index * 0.1,duration: 0.8}} viewport={{once: true}} className="bg-black rounded-lg p-6 text-center border border-yellow-500/20 hover:border-yellow-500/50 transition-all duration-300 hover:transform hover:scale-105" >
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={info.icon} className="h-8 w-8 text-black" />
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">{info.title}</h3>
                {info.link ? (
                  <a href={info.link} target={info.link.startsWith('http') ? '_blank' : undefined} rel={info.link.startsWith('http') ? 'noopener noreferrer' : undefined} className="text-gray-400 hover:text-yellow-400 transition-colors duration-200 text-sm leading-relaxed" >
                    {info.details}
                  </a>
                ) : (
                  <p className="text-gray-400 text-sm leading-relaxed">{info.details}</p>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form and Map */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <motion.div initial={{x: -50,opacity: 0}} whileInView={{x: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} >
              <h2 className="text-3xl font-bold text-white mb-6">Send us a Message</h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-400 mb-2">
                    Full Name
                  </label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 bg-gray-900 border border-yellow-500/20 rounded-lg text-white focus:outline-none focus:border-yellow-500 transition-colors duration-200" placeholder="Your full name" />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-400 mb-2">
                    Email Address
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 bg-gray-900 border border-yellow-500/20 rounded-lg text-white focus:outline-none focus:border-yellow-500 transition-colors duration-200" placeholder="your.email@example.com" />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-400 mb-2">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 bg-gray-900 border border-yellow-500/20 rounded-lg text-white focus:outline-none focus:border-yellow-500 transition-colors duration-200" placeholder="+1 (416) 123-4567" />
                </div>
                <div>
                  <label htmlFor="service" className="block text-sm font-medium text-gray-400 mb-2">
                    Service Interest
                  </label>
                  <select id="service" name="service" value={formData.service} onChange={handleChange} className="w-full px-4 py-3 bg-gray-900 border border-yellow-500/20 rounded-lg text-white focus:outline-none focus:border-yellow-500 transition-colors duration-200" >
                    <option value="">Select a service</option>
                    {services.map((service)=> (
                      <option key={service} value={service}>{service}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-400 mb-2">
                    Message
                  </label>
                  <textarea id="message" name="message" rows={5} value={formData.message} onChange={handleChange} required className="w-full px-4 py-3 bg-gray-900 border border-yellow-500/20 rounded-lg text-white focus:outline-none focus:border-yellow-500 transition-colors duration-200 resize-none" placeholder="Tell us about your appointment preferences or ask any questions..." />
                </div>
                <button type="submit" className="w-full bg-gradient-to-r from-yellow-400 to-yellow-600 text-black py-3 px-6 rounded-lg font-semibold hover:shadow-lg transition-all duration-300 flex items-center justify-center" >
                  <SafeIcon icon={FiSend} className="h-5 w-5 mr-2" />
                  Send Message
                </button>
              </form>
            </motion.div>

            {/* Map */}
            <motion.div initial={{x: 50,opacity: 0}} whileInView={{x: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} >
              <h2 className="text-3xl font-bold text-white mb-6">Find Us</h2>
              <div className="rounded-lg overflow-hidden border border-yellow-500/20 h-96">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2886.169943683877!2d-79.4669212!3d43.665435300000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b351e0d005825%3A0xae115751961f63df!2sWest%20End%20Barbers!5e0!3m2!1sen!2s!4v1764169491295!5m2!1sen!2s" width="100%" height="100%" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" ></iframe>
              </div>
              <div className="mt-6 p-6 bg-gray-900 rounded-lg border border-yellow-500/20">
                <h3 className="text-xl font-semibold text-white mb-4">Visit Our Shop</h3>
                <p className="text-gray-400 leading-relaxed mb-4">
                  We're conveniently located in Toronto's west end,easily accessible by public transit and with parking available nearby.
                </p>
                <a href="https://maps.app.goo.gl/uot5v9b8f7euibJm7" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-to-r from-yellow-400 to-yellow-600 text-black px-6 py-2 rounded-lg font-semibold hover:shadow-lg transition-all duration-300" >
                  Get Directions
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h2 initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{duration: 0.8}} viewport={{once: true}} className="text-3xl sm:text-4xl font-bold text-white mb-6" >
            Ready to Book Your Appointment?
          </motion.h2>
          <motion.p initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{delay: 0.2,duration: 0.8}} viewport={{once: true}} className="text-xl text-gray-400 mb-8" >
            Call us now or visit our shop to experience the West End Barbers difference
          </motion.p>
          <motion.a initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{delay: 0.4,duration: 0.8}} viewport={{once: true}} href="tel:+14166379929" className="inline-block bg-gradient-to-r from-yellow-400 to-yellow-600 text-black px-8 py-3 rounded-lg font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300 text-lg" >
            Call +1 (416) 637-9929
          </motion.a>
        </div>
      </section>
    </motion.div>
  );
}

export default Contact;